export default __webpack_public_path__ + "static/media/IconUserPay.0adabd1d.svg";